var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.15731 4.49031H8.88994V3.24707H3.74289C3.28514 3.24707 2.91406 3.61815 2.91406 4.0759V19.9964C2.91406 20.4542 3.28514 20.8253 3.74289 20.8253H19.4244C19.8821 20.8253 20.2532 20.4542 20.2532 19.9964V14.9371H19.01V19.582H4.15731V4.49031Z",
  fill: "#9498A0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.2148 4.47417C15.6123 3.07671 17.878 3.07671 19.2754 4.47417C20.6729 5.87163 20.6729 8.13736 19.2754 9.53481L13.0918 15.7185C12.8096 16.0007 12.4343 16.1706 12.036 16.1965L8.18317 16.4474C7.68381 16.4799 7.26974 16.0658 7.30225 15.5664L7.55306 11.7136C7.57899 11.3153 7.74892 10.94 8.03114 10.6578L14.2148 4.47417ZM18.3963 5.35328C17.4844 4.44133 16.0058 4.44133 15.0939 5.35328L8.91025 11.5369C8.84143 11.6057 8.8 11.6972 8.79368 11.7943L8.57354 15.1761L11.9553 14.9559C12.0524 14.9496 12.1439 14.9082 12.2127 14.8394L18.3963 8.65571C19.3083 7.74377 19.3083 6.26522 18.3963 5.35328Z",
  fill: "#9498A0"
});

function SvgEditJob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditJob);
export default __webpack_public_path__ + "static/media/EditJob.14418f7f.svg";
export { ForwardRef as ReactComponent };